import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    constructor(
        private translate: TranslateService,
        private toastr: ToastrService,
    ) {}

    trendGraphUpdateFailed() {
        this.toastr.error(this.translate.instant('notifications.trend-graph.errors.update-fail'));
    }

    channelUpdateComplete() {
        this.toastr.success(this.translate.instant('notifications.channel.update-success'));
    }

    alarmIsAlreadyAcked(alarmName) {
        this.toastr.error(this.translate.instant('notifications.alarm.error.already-acked', {alarmName: alarmName}));
    }

    alarmIsBeingAcked(alarmName){
        this.toastr.error(this.translate.instant('notifications.alarm.error.being-acked', {alarmName: alarmName}));
    }

    channelUpdateFailed() {
        this.toastr.error(this.translate.instant('notifications.channel.errors.update-fail'));
    }

    dashboardUpdateFail() {
        this.toastr.error(this.translate.instant('dashboard.errors.update-failed'), '', {
            timeOut: 6000,
            closeButton: true,
        });
    }

    dashboardLoadFail() {
        this.toastr.error(this.translate.instant('dashboard.errors.load-failed'), '', {
            timeOut: 6000,
            closeButton: true,
        });
    }

    projectSaveCompleted() {
        this.toastr.success(
            this.translate.instant('project-settings.error.project-save.completed'),
        );
    }

    projectSaveError() {
        this.toastr.error(this.translate.instant('project-settings.error.project-save.error'), '', {
            timeOut: 6000,
            closeButton: true,
        });
    }
}
